// extracted by mini-css-extract-plugin
export var activeIndex = "ContrastChecker-module--activeIndex--48021";
export var buttonControl = "ContrastChecker-module--buttonControl--35875";
export var cMarginTop = "ContrastChecker-module--c-margin-top--e02a6";
export var cPadding = "ContrastChecker-module--c-padding--1016e";
export var cPaddingBottom = "ContrastChecker-module--c-padding-bottom--22ac4";
export var cPaddingTop = "ContrastChecker-module--c-padding-top--d29a1";
export var colorBtn = "ContrastChecker-module--colorBtn--c5dfd";
export var colorControl = "ContrastChecker-module--colorControl--f9b91";
export var colorGroup = "ContrastChecker-module--colorGroup--2943c";
export var compliance = "ContrastChecker-module--compliance--f7156";
export var content = "ContrastChecker-module--content--98e99";
export var contrastNumber = "ContrastChecker-module--contrastNumber--f3fb0";
export var controls = "ContrastChecker-module--controls--ccb00";
export var date = "ContrastChecker-module--date--a9a36";
export var disabled = "ContrastChecker-module--disabled--fb300";
export var ellipsis = "ContrastChecker-module--ellipsis--258c4";
export var errorText = "ContrastChecker-module--errorText--85ae9";
export var fail = "ContrastChecker-module--fail--4ad15";
export var featuredSection = "ContrastChecker-module--featuredSection--fe5c8";
export var globalSpacing = "ContrastChecker-module--global-spacing--91c81";
export var globalSpacingBottom = "ContrastChecker-module--global-spacing-bottom--5a61d";
export var globalSpacingTop = "ContrastChecker-module--global-spacing-top--94ca0";
export var image = "ContrastChecker-module--image--3d359";
export var imageWrapper = "ContrastChecker-module--imageWrapper--b8855";
export var index = "ContrastChecker-module--index--afbf1";
export var inputWrapper = "ContrastChecker-module--inputWrapper--756b9";
export var listItem = "ContrastChecker-module--listItem--a115c";
export var lorem = "ContrastChecker-module--lorem--2b886";
export var maxWidth = "ContrastChecker-module--max-width--9a9a8";
export var navButton = "ContrastChecker-module--navButton--74ef0";
export var pagination = "ContrastChecker-module--pagination--ab98c";
export var para = "ContrastChecker-module--para--ecc96";
export var pass = "ContrastChecker-module--pass--07ad4";
export var preview = "ContrastChecker-module--preview--cbb8d";
export var styleTick = "ContrastChecker-module--styleTick--7f8bb";
export var swapBtn = "ContrastChecker-module--swapBtn--6be75";
export var tableData = "ContrastChecker-module--tableData--ecec2";
export var tag = "ContrastChecker-module--tag--49b70";
export var tagWrapper = "ContrastChecker-module--tagWrapper--ce621";
export var tdHead = "ContrastChecker-module--tdHead--4273e";
export var textCompliance = "ContrastChecker-module--textCompliance--3c1f4";
export var tip = "ContrastChecker-module--tip--1d084";
export var title = "ContrastChecker-module--title--bba5f";
export var wrapper = "ContrastChecker-module--wrapper--b4858";